import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'María G.',
    location: 'Córdoba',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 9 minutos'
  });
  const buyers = [{
    name: 'María G.',
    location: 'Córdoba',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 9 minutos'
  }, {
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 14 minutos'
  }, {
    name: 'Carolina P.',
    location: 'La Plata',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 22 minutos'
  }, {
    name: 'Ricardo A.',
    location: 'Mendoza',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 35 minutos'
  }, {
    name: 'Florencia B.',
    location: 'Rosario',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 41 minutos'
  }, {
    name: 'Agustina S.',
    location: 'CABA',
    product: 'Mega Pack Chi Kung 🌿',
    time: 'hace 52 minutos'
  }];
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        const randomTime = `hace ${Math.floor(Math.random() * 59) + 1} minutos`;
        setNotificationData({
          ...randomBuyer,
          time: randomTime
        });
        setIsVisible(true);
      }, 1000);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-82">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm" data-id="element-83">
          <div className="glass-panel bg-white/95 p-4 rounded-2xl shadow-xl border-brand-purple/30 flex items-start space-x-4 backdrop-blur-md" data-id="element-84">
            <div className="bg-brand-purple/10 p-2 rounded-full shrink-0 mt-1" data-id="element-85">
              <CheckCircle2 className="w-5 h-5 text-brand-purple" data-id="element-86" />
            </div>
            <div data-id="element-87">
              <div className="text-xs text-brand-text/60 mb-1 flex items-center" data-id="element-88">
                🔔 Compra verificada • {notificationData.time}
              </div>
              <div className="text-sm font-medium text-brand-text mb-1" data-id="element-89">
                <span className="font-bold" data-id="element-90">{notificationData.name}</span> de{' '}
                {notificationData.location} compró
              </div>
              <div className="text-sm text-brand-purple font-bold" data-id="element-91">
                {notificationData.product}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};